(function() {
  const STORAGE_KEY = 'thugswim_pending_discount_redirect_v1';
  const APPLIED_KEY = 'thugswim_discount_redirect_applied_v1';
  const PASSWORD_PATH = '/password';

  function safeGetStorage() {
    try {
      return window.sessionStorage;
    } catch (error) {
      return null;
    }
  }

  function sameOriginUrl(rawUrl) {
    try {
      return new URL(rawUrl, window.location.origin);
    } catch (error) {
      return null;
    }
  }

  function getDiscountCodeFromUrl(url) {
    if (!url) return '';

    const pathMatch = url.pathname.match(/^\/discount\/([^/?#]+)/i);
    if (pathMatch && pathMatch[1]) {
      return decodeURIComponent(pathMatch[1]).trim();
    }

    const queryCode = url.searchParams.get('discount') || url.searchParams.get('discount_code');
    return queryCode ? queryCode.trim() : '';
  }

  function buildDiscountRedirectUrl(url) {
    const code = getDiscountCodeFromUrl(url);
    if (!code) return '';

    if (url.pathname.match(/^\/discount\//i)) {
      return url.pathname + url.search + url.hash;
    }

    const redirectUrl = new URL(url.pathname + url.search + url.hash, window.location.origin);
    redirectUrl.searchParams.delete('discount');
    redirectUrl.searchParams.delete('discount_code');

    const redirectPath = redirectUrl.pathname + redirectUrl.search + redirectUrl.hash;
    return '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(redirectPath || '/');
  }

  function capturePendingDiscount() {
    const storage = safeGetStorage();
    if (!storage) return;

    const currentUrl = sameOriginUrl(window.location.href);
    if (!currentUrl) return;

    const builtUrl = buildDiscountRedirectUrl(currentUrl);
    if (builtUrl) {
      storage.setItem(STORAGE_KEY, builtUrl);
      storage.removeItem(APPLIED_KEY);
      return;
    }

    const form = document.querySelector('form[action="' + PASSWORD_PATH + '"]');
    if (!(form instanceof HTMLFormElement)) return;

    form.addEventListener('submit', function() {
      const liveUrl = sameOriginUrl(window.location.href);
      if (!liveUrl) return;
      const pendingUrl = buildDiscountRedirectUrl(liveUrl);
      if (pendingUrl) {
        storage.setItem(STORAGE_KEY, pendingUrl);
        storage.removeItem(APPLIED_KEY);
      }
    });
  }

  function applyPendingDiscount() {
    const storage = safeGetStorage();
    if (!storage) return;
    if (window.location.pathname === PASSWORD_PATH) return;

    const pendingUrl = storage.getItem(STORAGE_KEY);
    if (!pendingUrl) return;

    if (storage.getItem(APPLIED_KEY) === pendingUrl) {
      storage.removeItem(STORAGE_KEY);
      return;
    }

    const destination = sameOriginUrl(pendingUrl);
    if (!destination || destination.origin !== window.location.origin) {
      storage.removeItem(STORAGE_KEY);
      storage.removeItem(APPLIED_KEY);
      return;
    }

    storage.setItem(APPLIED_KEY, pendingUrl);
    storage.removeItem(STORAGE_KEY);
    window.location.replace(destination.pathname + destination.search + destination.hash);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      capturePendingDiscount();
      applyPendingDiscount();
    });
  } else {
    capturePendingDiscount();
    applyPendingDiscount();
  }
})();
